import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// API Base URL
const BASE_URL = "https://newalemny.3almny.app/api";

// Get subject books
export const getSubjectBooks = createAsyncThunk(
  "subjectBooks/getSubjectBooks",
  async ({ subjectId }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token3almny");
      const headers = {
        "Content-Type": "application/json",
      };

      // إضافة التوكن إذا كان موجود
      if (token) {
        headers.Authorization = `Bearer ${token}`;
      }

      const response = await fetch(`${BASE_URL}/subjects/subject_books/${subjectId}`, {
        headers: headers,
      });
      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || "حدث خطأ في جلب الكتب");
      }

      return data.result;
    } catch (error) {
      return rejectWithValue("حدث خطأ في الاتصال بالخادم");
    }
  }
);

const initialState = {
  subjectBooks: [],
  booksLoading: false,
  booksError: null,
  currentSubjectId: null,
};

const subjectBooksSlice = createSlice({
  name: "subjectBooks",
  initialState,
  reducers: {
    clearBooksError: (state) => {
      state.booksError = null;
    },
    resetBooks: (state) => {
      state.subjectBooks = [];
      state.booksLoading = false;
      state.booksError = null;
      state.currentSubjectId = null;
    },
    setCurrentSubjectId: (state, action) => {
      state.currentSubjectId = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Get Subject Books
    builder
      .addCase(getSubjectBooks.pending, (state) => {
        state.booksLoading = true;
        state.booksError = null;
      })
      .addCase(getSubjectBooks.fulfilled, (state, action) => {
        state.booksLoading = false;
        state.subjectBooks = action.payload;
      })
      .addCase(getSubjectBooks.rejected, (state, action) => {
        state.booksLoading = false;
        state.booksError = action.payload;
      });
  },
});

export const { clearBooksError, resetBooks, setCurrentSubjectId } = subjectBooksSlice.actions;
export default subjectBooksSlice.reducer;
